const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#F57C00', // Rich Orange
      light: '#FFE0B2', // Soft Orange
      dark: '#E65100', // Deep Orange
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FBC02D', // Soft Yellow
      light: '#FFF9C4', // Very Pale Yellow
      dark: '#C49000', // Deep Yellow/Gold
      contrastText: '#1a2138',
    },
    success: {
      main: '#2E7D32', // Muted Green for success
      light: '#E8F5E9',
      dark: '#1B5E20',
      contrastText: '#ffffff',
    },
    info: {
      main: '#0288D1', // Muted Blue
      light: '#E1F5FE',
      dark: '#01579B',
      contrastText: '#ffffff',
    },
    error: {
      main: '#D32F2F', // Standard Error Red
      light: '#FFEBEE',
      dark: '#C62828',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ED6C02', // Warning Orange
      light: '#FFF3E0',
      dark: '#E65100',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#F8FAFC',
      100: '#F1F5F9',
      200: '#E2E8F0',
      300: '#CBD5E1',
      400: '#94A3B8',
      500: '#64748B', // Primary Text-ish
      600: '#475569',
      700: '#334155',
      800: '#1E293B',
      900: '#0F172A',
      A100: '#F1F5F9',
      A200: '#E2E8F0',
      A400: '#94A3B8',
      A700: '#334155',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#1E293B', // Dark Slate Blue/Grey for sharp text
      secondary: '#64748B', // Muted Slate
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: 'rgba(245, 124, 0, 0.08)', // Soft orange hover
    },
    divider: '#E2E8F0',
    background: {
      default: '#FAFAFA', // Clean Warm White
      paper: '#FFFFFF', // Pure White
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#FF9800', // Brighter Orange for Dark Mode
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FFEB3B', // Brighter Yellow for Dark Mode
      light: '#FFF59D',
      dark: '#FBC02D',
      contrastText: '#1a2138',
    },
    success: {
      main: '#66BB6A',
      light: '#1B5E20',
      dark: '#338E3C',
      contrastText: '#ffffff',
    },
    info: {
      main: '#29B6F6',
      light: '#01579B',
      dark: '#0288D1',
      contrastText: '#ffffff',
    },
    error: {
      main: '#F44336',
      light: '#B71C1C',
      dark: '#D32F2F',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFA726',
      light: '#E65100',
      dark: '#F57C00',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#1a2138',
      100: '#1A2138',
      200: '#2A3447', // Muted Blue-Grey
      300: '#475569',
      400: '#64748B',
      500: '#94A3B8',
      600: '#CBD5E1',
      700: '#E2E8F0',
      800: '#F1F5F9',
      900: '#F8FAFC',
      A100: '#1A2138',
      A200: '#2A3447',
      A400: '#64748B',
      A700: '#E2E8F0',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#F8FAFC', // Near White
      secondary: '#94A3B8', // Muted Light Grey
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: 'rgba(255, 152, 0, 0.08)',
    },
    divider: '#2A3447',
    background: {
      default: '#0F172A', // Deep Slate Blue (Not Black)
      dark: '#0F172A',
      paper: '#1E293B', // Lighter Slate
    },
  },
};

export { baseDarkTheme, baselightTheme };
